module.exports = __webpack_public_path__ + "static/img/IMG_20170305_141747.ea1eb180.jpg";